(function () {
    "use strict";

    angular
        .module("app")
        .directive("transferChecklist", ["toaster", "$rootScope", "$q", "QUtil", "TransferChecklistService", "DocumentService", transferChecklist]);

    function transferChecklist(toaster, $rootScope, $q, qUtil, transferChecklistService, documentService) {
        return {
            restrict: "E",
            link: function (scope) {
                scope.showTransferMitigation = $rootScope.isFactoryUser !== true;

                scope.showCreate = false;

                scope.load = function () {
                    if (scope.prototypeId && scope.fromFactoryKey && scope.toFactoryKey) {
                        transferChecklistService.find(scope.prototypeId, scope.fromFactoryKey, scope.toFactoryKey).then(function (data) {
                            scope.showCreate = data.Data === null;

                            scope.checklist = data.Data;

                            scope.completionDateAtTimeOfLoad = scope.checklist.CompletionDate;

                            scope.setItemsEnabled();
                        });
                    }
                };

                scope.setItemsEnabled = function () {
                    if (!scope.checklist) return;

                    if (scope.checklist.IsTariffMitigationTransfer === true) {
                        _.each(scope.checklist.Items, function (item) {
                            item.IsEnabled = true;
                        });

                        return;
                    }

                    var productType = _.find(scope.productTypes, function (p) { return p.TransferProductTypeId === scope.checklist.TransferProductTypeId });

                    _.each(scope.checklist.Items, function (item) {
                        item.IsEnabled =
                            productType &&
                            _.some(productType.RequiredTemplateItems, function (i) { return i === item.TransferChecklistTemplateItemId; });
                    });
                }

                scope.itemEnabledChange = function () {
                    if (scope.allItemsChecked() && scope.checklist.TransferProductTypeId) {
                        if (scope.checklist.CompletionDate) {
                            return;
                        }

                        if (scope.completionDateAtTimeOfLoad) {
                            scope.checklist.CompletionDate = scope.completionDateAtTimeOfLoad;
                            return;
                        }

                        scope.checklist.CompletionDate = moment();
                    } else {
                        scope.checklist.CompletionDate = null;
                    }
                };

                scope.allItemsChecked = function () {
                    return _.every(scope.checklist.Items,
                        function (i) {
                            return i.IsComplete || !i.IsEnabled;
                        });
                };

                scope.onTariffMitigationTransferChange = function () {
                    scope.setItemsEnabled();
                    
                    transferChecklistService.syncPatternLevelItemsPreview(scope.checklist.TransferChecklistId, scope.checklist.IsTariffMitigationTransfer).then(function (data) {
                        var count = 0;

                        _.each(data, function(syncItem) {
                            _.each(scope.checklist.Items, function (item) {
                                if (syncItem.TransferChecklistItemId === item.TransferChecklistItemId && syncItem.IsComplete && !item.IsComplete) {
                                    item.IsComplete = syncItem.IsComplete;
                                    item.CompletedBy = syncItem.CompletedBy;
                                    item.CompletedOn = syncItem.CompletedOn;
                                    count++;
                                }
                            });
                        });

                        if (count > 0) {
                            toaster.pop({ type: "success", title: "Success!", body: count + " items were checked as a result of syncing this checklist with others in the pattern.", timeout: 5000 });
                        }
                    });
                };

                scope.createChecklist = function () {
                    scope.showCreate = false;

                    transferChecklistService.create(scope.prototypeId, scope.fromFactoryKey, scope.toFactoryKey).then(function (data) {
                        if (data.IsSuccessful) {
                            scope.checklist = data.Data;
                        } else {
                            toaster.pop({ type: "error", title: "Error!", body: data.Message, timeout: 5000 });
                        }

                        scope.setItemsEnabled();
                    });
                };

                scope.save = function (form) {
                    var deferred = $q.defer();

                    if (form.$valid === false) {
                        toaster.clear();
                        toaster.pop({ type: "error", title: "Error!", body: "Please review all fields indicated in red.", timeout: 5000 });
                        deferred.reject();

                        return deferred.promise;
                    }

                    transferChecklistService.save(scope.checklist).then(function (result) {
                        if (result.IsSuccessful) {
                            toaster.pop({ type: "success", title: "Success!", body: "Transfer Checklist saved successfully!", timeout: 5000 });
                            scope.load();
                            deferred.resolve(result);
                        } else {
                            toaster.pop({ type: "error", title: "Error!", body: result.Message, timeout: 5000 });
                            deferred.reject();
                        }
                    });

                    return deferred.promise;
                };

                scope.saveAndPrint = function (form) {
                    scope.save(form).then(function () {
                        transferChecklistService.getPdf(scope.checklist.TransferChecklistId).then(function (result) {
                            if (result.IsSuccessful) {
                                documentService.openTempDocument(result.Data, "application/pdf", "Transfer Checklist - " + scope.checklist.StockNumber + "-" + scope.checklist.ToFactoryName + ".pdf");
                            } else {
                                toaster.pop({ type: "error", title: "Error!", body: result.Message, timeout: 5000 });
                            }
                        });
                    });
                };

                scope.clearValidation = function (form) {
                    form.$setPristine();
                    form.$setUntouched();
                    scope.hasChanges = false;
                };

                scope.init = function () {
                    qUtil.whenAll([
                        function () {
                            return transferChecklistService.getTransferProductTypes().then(function (data) {
                                scope.productTypes = data;
                            });
                        }
                    ]).then(function () { });

                    scope.$watch("prototypeId", function (newValue) {
                        scope.load(newValue);
                    });
                };

                scope.init();

            },
            scope: { prototypeId: "=", fromFactoryKey: "=", toFactoryKey: "=", readOnly: "=" },
            templateUrl: templateUrl("app/directives/prototype/transferChecklist.directive.html")
        };
    }
})();

